module.exports = __webpack_public_path__ + "img/aboutUs.ec573140.png";